import { useState } from 'react'
import type { MagnitudeInputProps } from './contract'
import { MAG_LABELS, BANDS, bandOf } from '../../lib/scoring'
import { ensureAudio, tick, buzz } from '../../lib/sound'

/**
 * The no-gesture fallback: tap a band (units/K/M/B/T/Qa/Qi), then tap ×1/×10/×100.
 * Fully tap-driven, every target ≥44px — comfortable on desktop and for low motor skill.
 */
export function BandPad({ value, onChange, label, disabled }: MagnitudeInputProps) {
  const [openBand, setOpenBand] = useState<number | null>(value != null ? bandOf(value) : null)
  const band = value != null ? bandOf(value) : null
  const shown = openBand ?? band

  const pick = (stop: number) => { ensureAudio(); tick(); buzz(15); onChange(stop) }

  return (
    <div className="bandpad">
      <div className="bandpad-readout">{value == null ? 'pick a band' : label}</div>
      <div className="dial-bands">
        {BANDS.map((b, k) => (
          <button key={b.label} disabled={disabled} className={'band' + (k === band ? ' on' : k === shown ? ' open' : '')}
            onClick={() => { ensureAudio(); tick(true); setOpenBand(k); if (k === 6) pick(18) }}>{b.label}</button>
        ))}
      </div>
      <div className="bandpad-steps">
        {shown == null ? <span className="tiny">then ×1 · ×10 · ×100</span> :
          (shown === 6 ? [18] : [BANDS[shown].start, BANDS[shown].start + 1, BANDS[shown].start + 2]).map((i) => (
            <button key={i} className={'chip big' + (i === value ? ' on' : '')} onClick={() => pick(i)}>{MAG_LABELS[i]}</button>
          ))}
      </div>
    </div>
  )
}
